var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cbs-report-review"},[_c('el-dialog',{attrs:{"custom-class":"cbs-dialog","width":"25%","visible":_vm.visible},on:{"close":_vm.handleClose}},[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }